import { ParentalControlRating } from 'store/user/reducer.types';

import { EventParentalControlRating } from 'services/data-manager/types';

type ParentalTable = Record<
    ParentalControlRating,
    Record<EventParentalControlRating, boolean>
>;

const definitionTable: ParentalTable = {
    [ParentalControlRating.UNKNOWN]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU_UNRATED]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU_GENERAL]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU6]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU12]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU16]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU18]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU18_ADULT_CENSORED]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: true,
        [EventParentalControlRating.HU18_ADULT_UC]: true,
    },
    [ParentalControlRating.HU18_ADULT_UNCENSORED]: {
        [EventParentalControlRating.UNKNOWN]: false,
        [EventParentalControlRating.HU_GENERAL]: false,
        [EventParentalControlRating.HU_UNRATED]: false,
        [EventParentalControlRating.HU6]: false,
        [EventParentalControlRating.HU12]: false,
        [EventParentalControlRating.HU16]: false,
        [EventParentalControlRating.HU18]: false,
        [EventParentalControlRating.HU18_ADULT]: false,
        [EventParentalControlRating.HU18_ADULT_UC]: false,
    },
};

export default function needsToLockContent(
    userRating?: ParentalControlRating,
    eventRating?: EventParentalControlRating,
): boolean {
    if (userRating && eventRating) {
        return definitionTable[userRating]?.[eventRating];
    }

    return false;
}
